import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row g-0 w-100 align-items-stretch" }
const _hoisted_2 = { class: "card h-100 mx-5" }
const _hoisted_3 = { class: "card-header card-header-jaya small" }
const _hoisted_4 = { class: "card-body border-top" }
const _hoisted_5 = {
  class: "modal-body text-gray-800",
  style: {"text-align":"justify"}
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "col-8 d-flex flex-column justify-content-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "fs-3 text-primary" }, "Finalités du projet :", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "Ce projet a pour objectif de :", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "fs-3 text-primary" }, "Utilisation des données :", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Les données collectées pour ce projet "),
  /*#__PURE__*/_createElementVNode("strong", null, "sont à usage :")
], -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "fs-3 text-primary" }, "Détails sur le projet :", -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "fs-3 text-primary" }, "Projet en partenariat avec :", -1)
const _hoisted_17 = { class: "card-footer d-flex align-items-end justify-content-end" }
const _hoisted_18 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card_title_jaya = _resolveComponent("card-title-jaya")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, id) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col col-xl-6 col-12 mb-2",
        key: id
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_card_title_jaya, {
              "duotune-icon": "communication/com008",
              title: project.name,
              small: ""
            }, null, 8, ["title"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (project.prescriber?.image_url)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.getImageUrl(project.prescriber?.image_url),
                      alt: 'Logo de ' + project.prescriber.name,
                      class: "h-auto col-4 p-10"
                    }, null, 8, _hoisted_7))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("p", null, [
                    _createTextVNode(" Projet porté par : "),
                    _createElementVNode("strong", null, _toDisplayString(project.prescriber?.name), 1)
                  ])
                ])
              ]),
              _hoisted_9,
              _hoisted_10,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.project_purposes, (project_purpose, id) => {
                  return (_openBlock(), _createElementBlock("li", { key: id }, _toDisplayString(project_purpose), 1))
                }), 128))
              ]),
              _hoisted_11,
              _hoisted_12,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.gdpr_purposes, (purpose, id) => {
                  return (_openBlock(), _createElementBlock("li", { key: id }, _toDisplayString(purpose), 1))
                }), 128))
              ]),
              (project.details)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("p", null, _toDisplayString(project.details), 1)
                  ]))
                : _createCommentVNode("", true),
              (project.partners)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("p", null, _toDisplayString(project.partners), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("button", {
              class: "btn btn-outline-danger btn-sm border border-danger",
              onClick: ($event: any) => (_ctx.deleteProject(project))
            }, " Ne plus participer ", 8, _hoisted_18)
          ])
        ])
      ]))
    }), 128))
  ]))
}